import { AccountType } from "cy-remittance/registration";
import { AccountTypes } from "./models";
import { ReactNode } from "react";

export function renderAccountType(
  accountType: AccountType<AccountTypes>,
): ReactNode {
  switch (accountType.id) {
    case AccountTypes.SouthAfrican:
      return (
        <p>
          You will need a copy of your SA Green bar coded ID book or SA
          Smartcard ID.
        </p>
      );
    case AccountTypes.ForeignNational:
      return (
        <p>
          You will need a copy of your passport or temporary resident permit.
        </p>
      );
  }
}
